const excludeStyleProps = (props) => (prop) => !props.includes(prop);

export default excludeStyleProps;
